import { SideBarLinkProps } from "@/types/types";
import { Link } from "react-router-dom";

const SidebarLink = ({ data, pathname, isExpanded }: SideBarLinkProps) => {
  const isActive = pathname === data.path || pathname.includes(data.path);

  const client_dashboard_baseUrl =
    import.meta.env.VITE_NODE_ENV === "development"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_DEV
      : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_STAGE
      : import.meta.env.VITE_API_CLIENT_DASHBOARD_PROD;

  const handleRedirect = () => {
    if (data.isExternalRedirect) {
      // Compose full url dynamically
      window.location.href = `${client_dashboard_baseUrl}${data.path}`;
    }
  };

  const content = (
    <div
      className={`${
        isActive
          ? "md:bg-[#FEF4ED] md:border md:border-[#FFD6B9] md:rounded-[6px] text-[#FF6500]"
          : "text-[#62636C] bg-white border-none"
      }
       ${isExpanded ? "md:flex-row" : "md:flex-col"}
      px-3 py-2 flex h-full md:justify-start justify-center flex-col gap-x-2 w-full items-center md:items-start transform ease-in-out transition-all`}
    >
      <div className="w-[20px]">{data.icon}</div>
      {isExpanded && (
        <p className="opacity-100 whitespace-nowrap transform ease-in-out transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%] flex gap-2.5 items-center">
          {data.label}
        </p>
      )}
      <p className="whitespace-nowrap font-medium text-xs mt-1 block md:hidden">
        {data.label}
      </p>
    </div>
  );

  return (
    <li className="h-[70px] md:h-[40px]">
      {data.isExternalRedirect ? (
        <button className="w-full h-full text-left" onClick={handleRedirect}>
          {content}
        </button>
      ) : (
        <Link to={data.path}>{content}</Link>
      )}
    </li>
  );
};

export default SidebarLink;
